import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection, { faqs } from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

export default function SiouxFallsPage() {
  return (
    <>
      <CitySEOHead
        city="Sioux Falls"
        state="South Dakota"
        stateAbbr="SD"
        route="/cities/sioux-falls"
        title="Emergency Passport Sioux Falls, SD — Expedited & Fast Passport Service | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Sioux Falls, South Dakota. Serving Minnehaha County, Lincoln County, Brandon, Harrisburg, Tea, and Hartford. As fast as 24 hours — no Minneapolis agency trip needed."
        geoPlacename="Sioux Falls, South Dakota"
        geoPosition="43.5497;-96.7003"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="South Dakota"
        statePageRoute="/states/south-dakota"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <ServicesSection />
        <HowItWorksSection />
        <LocalAreaSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}